module.exports = __webpack_public_path__ + "img/fritschi_1.79de2c09.jpg";